<template>
  <div class="home xlbox" :style="{ height: pageHeight + 'px' }"  ref="articleRef">
    <van-nav-bar
      fixed
      title="线路故障统计"
      left-text=""
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="tj">
      <div class="item xltj">
        <van-pull-refresh v-model="isLoading"
          success-text="刷新成功"
          @refresh="onRefresh">
            <van-list
              v-model="loading"
              :finished="finished"
              :finished-text="finishText"
              @load="onLoad"
              :offset="10"
              :immediate-check='false'
            >
            <!-- <p>刷新次数: {{ count }}</p> -->
            <ul>
              <li
                v-for="(item, index) in listCount" :key="index" @click="mlineHistoryDiares(index)">
                <div class="xltit">
                  <i
                    :style="{
                      background: [index < 4 ? bcolor[index] : bcolor[3]],
                    }"
                    >{{ index + 1 }}</i
                  ><span>{{listMLName[index]}}</span>
                </div>
                <div>
                  <div class="progress">
                    <div
                      class="progress-bar"
                      :style="{ width: (listCount[index]/listCount[0])*100 + '%' }"
                    ></div>
                  </div>
                  <span class="num">{{ listCount[index] }}</span>
                </div>
                <div>
                  <span class="itext">接地：{{ listjd[index] }}</span>
                  <span class="itext">速断：{{ listsd[index] }}</span>
                  <span class="itext">过流：{{ listgl[index] }}</span>
                  <span class="itext">瞬时性短路：{{listssxdl[index]}}</span>
                </div>
              </li>
            </ul>
        </van-list>
        </van-pull-refresh>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Col, Row, Button, NavBar, List, PullRefresh } from 'vant'

// import axios from 'axios' // 引入axios进行前后端交互
Vue.use(Col, Row, Button, NavBar, List, PullRefresh)

export default {
  name: 'mlineDiaresPage',
  components: {
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh
  },
  data () {
    return {
      nodataShow: false,
      finishText: '没有更多了',
      isLoading: false,
      loading: false,
      finished: false,
      currentPage8: 1, // 当前页
      pagesize: 15, // 每页显示条数
      total: '', // 总条数
      totalPage: '', // 总页数
      offset: 50, // 滚动条与底部距离小于 offset 时触发load事件
      list: [ ],
      MlineDiaresList: {}, // 线路故障统计返回数据
      coloritem: ['#0B7DEC', '#F2B12F', '#0ED1C4', '#9FCBDC'], // 排序圆标背景色
      widthPrent: [50, 20, 10, 32], // 线路进度条宽度比
      listjd: [],
      listsd: [],
      listMLName: [],
      listMLineId: [],
      listgl: [],
      listssxdl: [],
      listbfb: [],
      listCount: [],
      pageHeight: window.innerHeight,
      scrollTop: 0, // 在data属性中记录滚动的距离
      firstTO: false // 是否第一次进入该页面标记
    }
  },
  watch: {
    // 使用watch 监听$router的变化
    $route (to, from) {
      // console.log(from.name)
      if (from.name === 'tjPage') {
        this.listCount = []
        this.listMLName = []
        this.listMLineId = []
        this.listbfb = []
        this.listgl = []
        this.listjd = []
        this.listsd = []
        this.listssxdl = []
        this.currentPage8 = 1
        this.getMlineDiares()
      }
    }
  },
  created () {
    // console.log('created')
    // console.log(this.$route.query.mlineId)
    this.currentPage8 = parseInt(localStorage.getItem('currentPage8') || 1) // 缓存里取到的都是字符串，根据实际情况转换。不让刚才11这种情况就来了。 以前没有缓存过分页，默认使用1.。.存储当前页,, 你是憨批吗？？？？这tm是设置还是取值？。。。 取值tm也不该在这儿取啊
    // this.firstTO = true
  },
  // 注意this.scrollTop是用户触发滚动事件获取的。
  activated () {
    this.$refs.articleRef.scrollTop = this.scrollTop
    // console.log('activated')
    // this.listCount = []
    // this.listMLName = []
    // this.listMLineId = []
    // this.listbfb = []
    // this.listgl = []
    // this.listjd = []
    // this.listsd = []
    // this.currentPage8 = 1
    // this.getMlineDiares()
  },
  mounted () {
    // console.log('mounted')
    this.onRefresh()
    let article = this.$refs.articleRef // 获取到根节点
    // 绑定onscroll事件，只要滚动鼠标就会触发该事件，记录滚动的值
    article.addEventListener('scroll', this.pageScroll, true)
  },
  methods: {
    onClickLeft () {
      this.$router.push({
        path: '/tjPage' // 跳转到统计页
      })
    },
    pageScroll () {
      // console.log(this.$refs.articleRef.scrollTop) // 有用就怪了
      this.scrollTop = this.$refs.articleRef.scrollTop
    },
    onRefresh () {
      this.currentPage8 = 1
      // this.list = []
      this.listCount = []
      this.listMLineId = []
      this.listMLName = []
      this.listbfb = []
      this.listgl = []
      this.listjd = []
      this.listsd = []
      this.listssxdl = []

      this.finished = false
      this.getMlineDiares()
      // this.isLoading=false
    },
    getMlineDiares () {
      localStorage.setItem('currentPage8', this.currentPage8)// 存储当前页
      // 线路故障统计
      this.util.post('/getMlineDiares', {
        currentPage: this.currentPage8, // 当前页
        pagesize: this.pagesize// 每页显示条数
      }).then(({ data }) => {
        if (data.code === 200) {
          this.MlineDiaresList = data.data
          // this.listCount = data.data.listCount
          // this.listMLName = data.data.listMLName
          // this.listbfb = data.data.listbfb
          // this.listgl = data.data.listgl
          // this.listjd = data.data.listjd
          // this.listsd = data.data.listsd

          this.total = data.data.total
          this.totalPage = data.data.totalPage

          // let infolist = data.data.listCount
          let listCount = data.data.listCount
          let listMLName = data.data.listMLName
          let listMLineId = data.data.listMLineId
          let listbfb = data.data.listbfb
          let listgl = data.data.listgl
          let listjd = data.data.listjd
          let listsd = data.data.listsd
          let listssxdl = data.data.listssxdl

          // console.log(listCount)// 获取数据的数组
          if (listCount.length > 0) {
            this.nodataShow = false
          }

          // 数据全部加载完成
          if (listCount) {
            // this.list = this.list.concat(infolist)
            this.listCount = this.listCount.concat(listCount)
            this.listMLName = this.listMLName.concat(listMLName)
            this.listMLineId = this.listMLineId.concat(listMLineId)
            this.listbfb = this.listbfb.concat(listbfb)
            this.listgl = this.listgl.concat(listgl)
            this.listjd = this.listjd.concat(listjd)
            this.listsd = this.listsd.concat(listsd)
            this.listssxdl = this.listssxdl.concat(listssxdl)
            // console.log(this.listCount)
            // console.log(listCount)
            // console.log(this.listbfb)

            this.$nextTick(() => {
              this.loading = false// 取消正在加载状态
              this.isLoading = false
              // 不限制的concat， 人家刷新了，还在保留着以前的数据啊？
              // this.list = this.currentPage === 1 ? this.list : this.list.concat(infolist)
              // console.log(this.list)
              if (this.currentPage8 < this.totalPage) { // 判断接口返回数据量小于请求数据量，则表示此为最后一页
                this.finished = false
              } else {
                this.finished = true
                if (this.listCount.length === 0) {
                  this.nodataShow = true
                  this.finishText = ''
                } else {
                  this.nodataShow = false
                  this.finishText = '没有更多了'
                }
              }
            })
          } else {
            this.loading = false// 取消正在加载状态
            this.isLoading = false
            this.finished = true
          }
          // console.log(this.MlineDiaresList)
        } else {
          this.loading = false
          this.isLoading = false
          this.currentPage8 -= 1
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    },
    onLoad () {
      if (!this.isLoading) {
        this.currentPage8 += 1
        this.getMlineDiares()
      }
    },
    mlineHistoryDiares (index) {
      // console.log(this.MlineDiaresList.listMLineId[index])
      this.$router.push({
        path: '/mlineHistoryDiaresPage', query: { mlineId: this.listMLineId[index] } // 跳转到线路历史故障页
      })
    }
  },
  computed: {
    bcolor: function () {
      return this.coloritem
    }
    // pwidth: function () {
    //   return this.widthPrent
    // }
  }
}
</script>

<style scoped lang="less">
/deep/.van-nav-bar__content {
  height: 46px;
  background-color: #0b7dec;
}
/deep/.van-nav-bar__title,
/deep/.van-nav-bar .van-icon {
  font-size: 17px;
  color: #fff;
}
.home{
  padding-top: 46px;
}
</style>
